import React, { useEffect } from 'react';
import './App.css';
import './responsive.css';
import 'react-toastify/dist/ReactToastify.css';
import { Routes, Route } from 'react-router-dom';
import HomeScreen from './screens/HomeScreen';
import SingleProduct from './screens/SingleProduct';
import Login from './screens/Login';
import Register from './screens/Register';
import ForgotPassword from './screens/ForgotPassword';
import PasswordReset from './screens/PasswordReset';
import CartScreen from './screens/CartScreen';
import UserInfoScreen from './screens/UserInfoScreen';
import UserAddressScreen from './screens/UserAddressScreen';
import ShippingScreen from './screens/ShippingScreen';
import ProfileScreen from './screens/ProfileScreen';
import PaymentScreen from './screens/PaymentScreen';
import DeliveryScreen from './screens/DeliveryScreen';
import PlaceOrderScreen from './screens/PlaceOrderScreen';
import Preorder from './screens/PreorderScreen';
import OrderScreen from './screens/OrderScreen';
import NotFound from './screens/NotFound';
import { useAuth } from './hooks/useAuth';
import Shop from './screens/Shop';
import { wakeUp } from './service/ProductsService';
import ShippingPolicy from './screens/ShippingPolicy';

const App = () => {
  const { user } = useAuth();

  useEffect(() => {
    wakeUp();
  }, []);

  return (
    <Routes>
      <Route path='/' element={<HomeScreen />} exact />
      <Route path='/shop' element={<Shop />} />
      <Route path='/shop/:id' element={<Shop />} />
      <Route path='/products/:id' element={<SingleProduct user={user} />} />
      <Route path='/login' element={<Login />} />
      <Route path='/register' element={<Register user={user} />} />
      <Route path='/forgot-password' element={<ForgotPassword />} />
      <Route path='/password-reset/:token' element={<PasswordReset />} />
      <Route path='/profile' element={<ProfileScreen user={user} />} />
      <Route path='/cart' element={<CartScreen user={user} />} />
      <Route path='/preorder/:id' element={<Preorder user={user} />} />
      <Route path='/user-info/:id' element={<UserInfoScreen user={user} />} />
      <Route
        path='/user-address/:id'
        element={<UserAddressScreen user={user} />}
      />
      <Route path='/shipping/:id' element={<ShippingScreen user={user} />} />
      <Route path='/delivery/:id' element={<DeliveryScreen user={user} />} />
      <Route path='/payment/:id' element={<PaymentScreen user={user} />} />
      <Route
        path='/placeorder/:id'
        element={<PlaceOrderScreen user={user} />}
      />
      <Route path='/order/:id' element={<OrderScreen user={user} />} />
      <Route path='/shipping-policy' element={<ShippingPolicy />} />
      <Route path='*' element={<NotFound />} />
    </Routes>
  );
};

export default App;
